export const DEFAULT_DISPLAY_NAME = { displayName: 'Москва и МО', titleForRender: 'Москвы' };

export const DEFAULT_REGION_FILTER = { slug: 'msk', displayName: 'Москва и МО', titleForRender: 'Москвы' };
